module.exports = __webpack_public_path__ + "img/el_farolito.adf345d6.svg";